import { create } from "zustand"
import { persist } from "zustand/middleware"
import localStorageNames from "data/localStorageNames"

export const useTokenCredentials = create(persist((set, get) => ({
    tokenCredentials: {}, 
    updateTokenCredentials: (newTokens) => {
        set({ tokenCredentials: newTokens })
    }, 
    getTokenCredentials: () => {
        return get().tokenCredentials
    }
}),
    {
        name: localStorageNames.TOKEN
    }
))